import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { RequestService, LayoutUtilsService, LoaderService } from '../../../shared/services';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { FirebaseHandlersService } from '../../services/firebase-handlers.service';
import { NotificationService } from '../../services/notification.service';
import { SendbirdService } from '../../services/sendbird.service';
import { AlertEntityDialogComponent } from '../modals';

@Component({
	selector: 'app-user-view-dialog-modal',
	templateUrl: './custom-user-view-dialog.component.html',
	styleUrls: ['./custom-user-view-dialog.component.scss']
})
export class ModalUserViewDialogComponent implements OnInit {
	private subscriptions: Subscription[] = [];
	public errorMessage: string = '';
	public organization: any = undefined;
	public orgId = undefined;
	public scopes: string[] = [];
	public loading: boolean = false;
	public dataType: any = 'user'
	public hasFormErrors: boolean = false;
	public pictureLink: string = 'assets/images/profile.png';
	public fieldsDetails: any = undefined;
	public permission: any[] = [];
	public metaFieldTabsSetting = [];
	public tableDataTemp: any = undefined;
	// public DND: boolean = false;
	public isProfile: boolean = false;
	public showChangePassword: boolean = false;
	public normalDisplay: string[] = ['string', 'integer', 'phone', 'number', 'email', 'textarea'];
	public isDnd: boolean = false;
	public isAdmin: boolean = false;

	constructor(
		public dialog: MatDialog, private translate: TranslateService,
		private requestService: RequestService,
		private layoutUtilsService: LayoutUtilsService,
		public dialogRef: MatDialogRef<ModalUserViewDialogComponent>,
		private loaderService: LoaderService, private sendBirdService: SendbirdService,
		@Inject(MAT_DIALOG_DATA) public data: any, private firebaseHandler: FirebaseHandlersService, private notificationService: NotificationService) {
		// console.log('UserViewDialogData', data);
		if (data && data.profile) {
			this.isProfile = data.profile;
			this.isAdmin = this.requestService.isUserRoleAdmin();
		}
	}

	ngOnInit() {
		this.subscriptions.push(
			this.requestService.pageOrganization.subscribe((data) => {
				if (data) {
					this.organization = data;
					this.orgId = data._id;
				}
			})
		);

		this.subscriptions.push(this.notificationService.dnd.subscribe(async (isDnd) => {
			this.isDnd = isDnd;
		}));
	}
	ngOnDestroy() {
		this.subscriptions.forEach((s) => s.unsubscribe());
	}

	convertArrayToObject(arr: any[]) {
		let obj = {};
		for (let a of arr) {
			obj[a._id] = a;
		}
		return obj;
	}
	closeModal(data): void {
		this.dialogRef.close(data);
	}

	public viewTranscript(transcript: any) {
		window.open(transcript.fileLink, '_blank');
	}
	// changeDND(event) {
	// 	console.log(event.checked);
	// 	localStorage.setItem("DND", JSON.stringify(event.checked))
	// }

	saveDnd() {
		this.loaderService.display(true);
		this.requestService.postRequest('user', 'update', {
			userId: this.data.data._id,
			dnd: this.isDnd
		}, async (data, error) => {
			if (data) {
				if (this.isDnd) {
					const dialog = this.dialog.open(AlertEntityDialogComponent, {
						data: {
							description: this.translate.instant('Notifications for incoming chat messages and alerts are turned off. You will only be notified about high priority alerts.')
						}
					});
					// let topics = this.firebaseHandler.subscribedTopics.filter(i => {
					// 	return !i.includes('high-');
					// });
					// if (topics?.length) {
					// 	await this.firebaseHandler.unsubscribeTopic(topics, this.data.data._id);
					// }

					// await this.sendBirdService.unRegisterToken(this.data.data._id, this.firebaseHandler.token);
					// await this.firebaseHandler.unregisterDevice(this.data.data._id, this.firebaseHandler.token, () => {
					this.layoutUtilsService.showNotification(this.translate.instant('Updated Successfully'), this.translate.instant('Dismiss'));
					// }).catch((e) => {
					// this.layoutUtilsService.showNotification('Error: ' + e, this.translate.instant('Dismiss'));
					// }).finally(() => this.loaderService.display(false));
					this.loaderService.display(false);
				}
				// else {
				// let userRole = this.requestService.getUserRole();
				// let topics = [`high-${userRole}`, userRole];

				// if (this.requestService.currentUser?.agency) {
				// 	topics.push(`high-All Agencies`);
				// 	if (this.requestService.currentUser.agency_name) {
				// 		topics.push(`high-${this.requestService.currentUser.agency_name}`);
				// 		topics.push(this.requestService.currentUser.agency_name);
				// 	}
				// }

				// if (this.requestService.currentUser?.business_state) {
				// 	topics.push(`high-All States`);
				// 	if (this.requestService.currentUser.business_state) {
				// 		topics.push(`high-${this.requestService.currentUser.business_state}`);
				// 	}
				// }

				// if (this.requestService.currentUser?.codesAndStatuses) {
				// 	this.requestService.currentUser.codesAndStatuses.AccessPoint.forEach(point => {
				// 		if (point && point != '{}') {
				// 			topics.push(`high-${point}`);
				// 			topics.push(point);
				// 		}
				// 	});

				// 	// this.requestService.currentUser.codesAndStatuses.AgentCode.forEach(code => {
				// 	// 	if (code && code != '{}') {
				// 	// 		topics.push(`high-${code}`);
				// 	// 		topics.push(code);
				// 	// 	}
				// 	// });

				// 	// topics.push(`high-All Carriers`);
				// 	// this.requestService.currentUser.codesAndStatuses.Carrier.forEach(carrier => {
				// 	// 	if (carrier && carrier != '{}') {
				// 	// 		topics.push(`high-${carrier}`);
				// 	// 		topics.push(carrier);
				// 	// 	}
				// 	// });
				// }

				// this.firebaseHandler.subscribeTopic(topics, this.requestService.currentUser._id);
				// this.firebaseHandler.registerToken(this.firebaseHandler.token).then(() => {
				// 	this.loaderService.display(false);
				// 	this.layoutUtilsService.showNotification(this.translate.instant('Updated Successfully'), this.translate.instant('Dismiss'));
				// });
				this.loaderService.display(false);
				// }
			}
			else if (error) {
				this.layoutUtilsService.showNotification('Error: ' + error, this.translate.instant('Dismiss'));
				this.loaderService.display(false);
			}
			// localStorage.setItem('dnd', this.isDnd + '');
			// this.notificationService.dnd.next(this.isDnd);
		});
	}
}
